import { pickObject } from '@client/new/helpers/general';
import { ZodShape } from '@client/new/helpers/types';
import {
  CreatePdfInput,
  CreateTabInput,
  UpdatePdfInput,
  ContentAccessMethod,
} from 'generated/graphql';
import * as z from 'zod';
import {
  idValidator,
  createStringValidator,
  optionalUrlValidator,
} from './zod.utils';

const maxTitleLength = 500;
const maxNameLength = 200;
const minContentLength = 1;

const createTabInputShape: ZodShape<CreateTabInput> = {
  id: idValidator.optional(),
  parentId: idValidator,
  name: createStringValidator(minContentLength, maxNameLength, 'Tab name'),
  isPublished: z.boolean().optional(),
};
export const createTabInputSchema = z.object(createTabInputShape);

export const commonInputShape = pickObject(createTabInputShape, [
  'id',
  'isPublished',
  'parentId',
]);

export const commonUpdateShape = pickObject(createTabInputShape, [
  'id',
  'isPublished',
]);

const createPDFInputShape: ZodShape<CreatePdfInput> = {
  ...commonInputShape,
  title: createStringValidator(minContentLength, maxTitleLength, 'PDF title'),
  coverURL: optionalUrlValidator,
  downloadable: z.boolean().optional().default(true),
  fileName: z.string().optional(),
};

export const createPDFInputSchema = z.object(createPDFInputShape);

const editPDFInputShape: ZodShape<UpdatePdfInput> = {
  ...commonUpdateShape,
  title: createStringValidator(minContentLength, maxTitleLength, 'PDF title'),
  coverURL: optionalUrlValidator,
  downloadable: z.boolean().optional().default(true),
  fileName: z.string().optional(),
  accessMethod: z.nativeEnum(ContentAccessMethod).optional(),
  isArchived: z.boolean().optional(),
};

export const updatePDFInputSchema = z.object(editPDFInputShape).passthrough();
